import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ModelVariantConfigurationTabs from './ModelVariantConfigurationTabs';
import { useSelector } from 'react-redux';
import { getModelManager, getModelVariantManager } from '../../selectors/index';
import s from './ModelVariantConfigurationContentTemplate.module.scss';
import { useParams } from 'react-router-dom';
import {   describeModelVariantThunk } from '../../actions/modelVariant';

const ModelVariantConfigurationContentTemplate = ({ children, selectedPage = '', userProfileWidgets, intl }) => {
  let { ModelCategoryId, ModelId, ModelVariantId } = useParams();
  const modelVariantManager = useSelector(state => getModelVariantManager(state));
  const dispatch = useDispatch();

  useEffect(() => {
    if (ModelVariantId && ModelCategoryId) {
      // Fetch model details if not already available
      if (!modelVariantManager.selectedModelVariant || modelVariantManager.selectedModelVariant.ModelVariantId != ModelVariantId) {
        dispatch(describeModelVariantThunk(ModelVariantId, false, 'MODELVARIANTCONFIGURE', ModelCategoryId));
      }
    }
  }, [dispatch, ModelVariantId, ModelCategoryId]);



  const modelVariantName = (modelVariantManager.selectedModelVariant ? modelVariantManager.selectedModelVariant.Name  : '') || '';
  const titleHeading = intl.formatMessage({ id: 'modelVariant.configureModelVariant', defaultMessage: 'Model Variant Configuration' }) + (modelVariantName ? ` - ${modelVariantName}` : '');
  return (
    <Fragment>
      <div className={s.fullWidth}>
        <div className={s.fullWidthWrapper}>
          <h1 className={s.tabHeader}>{titleHeading}</h1>
          {<ModelVariantConfigurationTabs selectedPage={selectedPage} userProfileWidgets={userProfileWidgets} />}
        </div>
      </div>

      <div className={s.pageContent}>{children}</div>
    </Fragment>
  )
};

ModelVariantConfigurationContentTemplate.propTypes = {
  backLink: PropTypes.string,
  children: PropTypes.node.isRequired,
  selectedPage: PropTypes.string,
  userProfileWidgets: PropTypes.object
};

export default ModelVariantConfigurationContentTemplate;
